import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as ArrowRightIconSvg } from './arrow-right.svg';
import { ReactComponent as CarouselArrowIconSvg } from './carousel-arrow.svg';
import { ReactComponent as FbIconSvg } from './fb-icon.svg';
import { ReactComponent as FbDarkIconSvg } from './fb-icon-dark.svg';
import { ReactComponent as LnIconSvg } from './ln-icon.svg';
import { ReactComponent as LnIconDarkSvg } from './ln-icon-dark.svg';
import { ReactComponent as InstagramIconSvg } from './instagram-icon.svg';
import { ReactComponent as InstagramIconDarkSvg } from './instagram-icon-dark.svg';
import { ReactComponent as EmailIconSvg } from './email-icon.svg';
import { ReactComponent as PhoneIconSvg } from './phone-icon.svg';
import { ReactComponent as ConstructionIconSvg } from './construction-icon.svg';
import { ReactComponent as BigArrowRightIconSvg } from './big-arrow-right.svg';
import { ReactComponent as LogoU1Svg } from './logo-u1.svg';
import { ReactComponent as CloseIconSvg } from './close-icon.svg';
import { ReactComponent as ConstructionOrangeIconSvg } from './constructionOrangeIconSvg.svg';
import { ReactComponent as PlusIconSvg } from './plus-icon.svg';
import { ReactComponent as MinusIconSvg } from './minus-icon.svg';
import { ReactComponent as CalendarIconSvg } from './calendarIconSvg.svg';
import { ReactComponent as CheckboxIconSvg } from './checkbox-icon.svg';
import { ReactComponent as CheckboxCheckedIconSvg } from './checkbox-checked-icon.svg';
import { ReactComponent as OrangeArrowIconPosSvg } from './orange-arrow-icon.svg';
import { ReactComponent as TwitterIconSvg } from './twitter.svg';
import { ReactComponent as ShareIconSvg } from './share-icon.svg';
import { ReactComponent as ArrowIconSvg } from './ArrowIconSvg.svg';
import { ReactComponent as ArrowLeftGreyIconSvg } from './arrow-left-grey.svg';
import { ReactComponent as CloseMenuIconSvg } from './close-menu-icon.svg';
import { ReactComponent as ClosePopupButtonIconSvg } from './close-popup-button.svg';

export const ArrowRightIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ArrowRightIconSvg ref={ref} {...props} />);
export const FbIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <FbIconSvg ref={ref} {...props} />);
export const FbDarkIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <FbDarkIconSvg ref={ref} {...props} />);
export const LnIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LnIconSvg ref={ref} {...props} />);
export const LnDarkIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LnIconDarkSvg ref={ref} {...props} />);
export const InstagramIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <InstagramIconSvg ref={ref} {...props} />);
export const InstagramDarkIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <InstagramIconDarkSvg ref={ref} {...props} />
));
export const EmailIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EmailIconSvg ref={ref} {...props} />);
export const PhoneIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PhoneIconSvg ref={ref} {...props} />);
export const ConstructionIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ConstructionIconSvg ref={ref} {...props} />
));
export const BigArrowRightIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <BigArrowRightIconSvg ref={ref} {...props} />
));
export const LogoU1 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LogoU1Svg ref={ref} {...props} />);
export const CloseIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <CloseIconSvg ref={ref} {...props} />);
export const ConstructionOrangeIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ConstructionOrangeIconSvg ref={ref} {...props} />
));
export const PlusIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PlusIconSvg ref={ref} {...props} />);
export const MinusIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <MinusIconSvg ref={ref} {...props} />);
export const CheckboxIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <CheckboxIconSvg ref={ref} {...props} />);
export const CheckboxCheckedIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <CheckboxCheckedIconSvg ref={ref} {...props} />
));
export const TwitterIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <TwitterIconSvg ref={ref} {...props} />);
export const ShareIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ShareIconSvg ref={ref} {...props} />);

interface Position {
  position: 'right' | 'left' | 'up' | 'down';
}

export enum PositionValues {
  left = 0,
  up = 90,
  right = 180,
  down = 270,
}

interface SvgIconPositionProps extends SvgIconProps, Position {}

export const CarouselArrowIconPos = forwardRef<SVGSVGElement, SvgIconPositionProps>((props, ref) => (
  <CarouselArrowIconSvg style={{ transform: `rotate(${PositionValues[props.position]}deg)` }} ref={ref} {...props} />
));
export const CalendarIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <CalendarIconSvg ref={ref} {...props} />);

export const OrangeArrowIconPos = forwardRef<SVGSVGElement, SvgIconPositionProps>((props, ref) => (
  <OrangeArrowIconPosSvg style={{ transform: `rotate(${PositionValues[props.position]}deg)` }} ref={ref} {...props} />
));

export const ArrowIcon = forwardRef<SVGSVGElement, SvgIconPositionProps>((props, ref) => (
  <ArrowIconSvg style={{ transform: `rotate(${PositionValues[props.position]}deg)` }} ref={ref} {...props} />
));

export const ArrowLeftGreyIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ArrowLeftGreyIconSvg ref={ref} {...props} />
));
export const CloseMenuIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <CloseMenuIconSvg ref={ref} {...props} />);
export const ClosePopupButtonIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ClosePopupButtonIconSvg ref={ref} {...props} />
));
